import { FC, ReactNode, useEffect } from 'react';

import { useResponse } from 'contexts/response';

import Dialog, { useDialog } from './dialog';

interface SuccessDialogProps {
  title?: string;
  bodyText?: ReactNode;
  actionButtonLabel?: string;
  closeButtonLabel?: string;
  onActionClick?: () => void;
  width?: string;
}

const SuccessDialog: FC<SuccessDialogProps> = ({
  title = 'Request Success',
  bodyText,
  actionButtonLabel,
  closeButtonLabel,
  onActionClick,
  width
}) => {
  const { closeDialog, openDialog, ref } = useDialog();
  const { success, setSuccess } = useResponse();

  useEffect(() => {
    if (!success && ref.current?.open) {
      closeDialog();
    } else if (success && !ref.current?.open) {
      openDialog();
    }
  }, [ref, success, closeDialog, openDialog]);

  return (
    <Dialog closeDialog={() => setSuccess(null)} ref={ref} width={width} data-cy="success-dialog">
      <div className="d-flex flex-column g-3">
        <h3 className="text-info-dark font-weight-medium">{title}</h3>
        <div className="text-info-main">{bodyText || success}</div>
        <div className={actionButtonLabel && onActionClick ? 'd-flex justify-content-center g-3 mt-3 flex-wrap' : 'grid-3 mt-3'}>
          {actionButtonLabel && onActionClick ? (
            <>
              <button
                className="btn-outline"
                onClick={() => setSuccess(null)}
                data-cy="success-dialog-no"
              >
                {closeButtonLabel || 'NO'}
              </button>
              <button
                className="btn-primary"
                onClick={() => {
                  onActionClick();
                  setSuccess(null);
                }}
                data-cy="success-dialog-yes"
              >
                {actionButtonLabel || 'YES'}
              </button>
            </>
          ) : (
            <button
              className="btn-outline col-start-3"
              onClick={() => setSuccess(null)}
              data-cy="success-dialog-close"
            >
              {closeButtonLabel || 'close'}
            </button>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default SuccessDialog;
